import moment from 'moment';
/**
 * @Title: 时间处理-工具类提供一些便捷地工具服务
 *
 * =====================================================================
 * @Description: 工具索引
 *     2、formatAddTime 时间 加法 并 格式化时间
 *     3、formatSubtractTime 时间 减法 并 格式化时间
 *     4、formatInitTime 格式化 初始 时间
 * ============================================================================
 */

let util = {};
/**
 * 为秒的时间戳，默认乘上100
 * @param norms 默认乘上1000
 * @param time 需要格式化时间  默认当前时间
 * @param norms 格式化规则 默认 YYYY-MM-DD
 *
 * @Description:
 */
// 时间戳为ms
util.secTime = function (time, norms = 'YYYY-MM-DD') {
    return time && moment(time).format(norms) || '-';
};
// 时间戳为s
util.secTime1000 = function (time, norms = 'YYYY-MM-DD') {
    return time && moment(time*1000).format(norms) || '-';
};
/**
 *
 * @param time 需要格式化时间  默认当前时间
 * @param norms 格式化规则 默认 YYYY-MM-DD
 *
 * @Description:
 */
util.formatTime = function (time = new Date(), norms = 'YYYY-MM-DD') {
    return time && moment(time).format(norms) || '-';
};

/**
 * @Title: 2、时间 加法 并 格式化时间
 *
 * @param time 需要格式化时间  默认当前时间
 * @param norms 格式化规则 默认 YYYY-MM-DD
 * @param addNum 加数
 * @param addNorms 加法规则 默认 'days'
 *
 * @Description:
 */
util.formatAddTime = function (time = new Date(), norms = 'YYYY-MM-DD', addNum = 1, addNorms = 'days') {
    return time && moment(time).add(addNum, addNorms).format(norms) || '';
};

/**
 * @Title: 3、时间 减法 并 格式化时间
 *
 * @param time 需要格式化时间  默认当前时间
 * @param norms 格式化规则 默认 YYYY-MM-DD
 * @param addNum 减数
 * @param addNorms 减法规则 默认 'days'
 *
 * @Description:
 */
util.formatSubtractTime = function (addNum = 1, addNorms = 'days', time = new Date(), norms = 'YYYY-MM-DD') {
    return time && moment(time).subtract(addNum, addNorms).format(norms) || '';
};

/**
* @Description:将m转化为hh:mm:ss的格式
*/
util.hms = function(second_time){
    var time = parseInt(second_time);
    if( parseInt(second_time )> 60){

        var second = parseInt(second_time) % 60;
        second = second>9?second:'0'+second;
        var min = parseInt(second_time / 60);

        time = min + ":" + second ;
        if( min > 60 ){
            min = parseInt(second_time / 60) % 60;
            min = min>9?min:'0'+min;
            var hour = parseInt( parseInt(second_time / 60) /60 );
            hour = hour>9?hour:'0'+hour;
            time = hour + ":" + min + ":" + second ;

            if( hour > 24 ){
                hour = parseInt( parseInt(second_time / 60) /60 ) % 24;
                hour = hour>9?hour:'0'+hour;
                var day = parseInt( parseInt( parseInt(second_time / 60) /60 ) / 24 );
                time = day + "天" + hour + ":" + min + ":" + second ;
            }
        }
    }else{
        time = second_time
    }

    return time;
};
/**
 * @Description:获取上月的第一天（时间戳）
 */
util.lastMonth= function () {
   return moment().month(moment().month() - 1).startOf('month').valueOf()
}
/**
 * @Description:获取上月的最后一天（时间戳）
 */
util.lastDay= function () {
    return moment().month(moment().month() - 1).endOf('month').valueOf();
}
/**
 * @Description:获取当前月的第一天（时间戳）
 */
util.nowMonth= function () {
    return  moment().startOf('month').valueOf();
}
/**
 * @Description:获取当前时间戳
 */
util.nowtiming= function () {
    return moment().valueOf()
}



export default{
    install: function (Vue, options) {
        Vue.prototype.moment = util
    }
}
